import { AppButton } from '@clickguard/design-system'
import { useState, useCallback, ChangeEvent } from 'react'
import { FiUsers } from 'react-icons/fi'
import { GDialog, GInput } from 'components/basic-blocks'
import { useStores } from 'hooks'
import { Assets } from 'services/user/assets'
import { toast } from 'react-toastify'

export const InviteTeamMemberTracking = () => {
	const {
		assetStore: { asset },
		accountStore: { account }
	} = useStores()

	const [showInviteModal, setShowInviteModal] = useState(false)
	const [inviteEmail, setInviteEmail] = useState('')
	const [isSendingInvite, setIsSendingInvite] = useState(false)

	const handleSendInvite = useCallback(async () => {
		if (!inviteEmail.trim()) return
		if (!account?.id || !asset?.id) {
			toast.error('Account or asset information is missing')
			return
		}
		setIsSendingInvite(true)
		try {
			await Assets.sendTrackingCodeEmail(
				account.id,
				asset.id,
				inviteEmail
			)
			setInviteEmail('')
			setShowInviteModal(false)
			toast.success('Invite sent successfully!')
		} catch (error: unknown) {
			const err = error as {
				response?: { data?: { message?: string } }
			}
			toast.error(
				err?.response?.data?.message ||
					'Failed to send. Please try again.'
			)
		} finally {
			setIsSendingInvite(false)
		}
	}, [inviteEmail, account?.id, asset?.id])

	return (
		<>
			<GDialog
				open={showInviteModal}
				onClose={() => setShowInviteModal(false)}
				showClose={false}
				maxWidth="md"
				className="p-8 px-12 !max-w-[556px]"
			>
				<div className="flex flex-col gap-6">
					<div className="flex flex-col gap-2">
						<h2 className="text-3xl leading-[30px] font-semibold text-t-default">
							Invite a team member to complete this step
						</h2>
						<p className="text-[16px] leading-[22px] text-t-desc-gray">
							We will send an email for them to create an account and continue the process.
						</p>
					</div>
					<GInput
						name="invite-email"
						label="Email"
						placeholder="example@clickguard.com"
						type="email"
						value={inviteEmail}
						onChange={(
							e: ChangeEvent<HTMLInputElement>
						) => setInviteEmail(e.target.value)}
						labelClassName="text-[14px] leading-[18px] font-medium text-t-google-ad"
						inputClassName="w-full text-[16px] leading-[22px] text-t-coupon"
					/>
					<AppButton
						variant="marketing"
						size="lg"
						fullWidth
						label="Send invite"
						isLoading={isSendingInvite}
						loader="dots"
						disabled={!inviteEmail.trim() || isSendingInvite}
						onClick={handleSendInvite}
					/>
				</div>
			</GDialog>

			<button
				className="flex items-center justify-center gap-[5px] text-[14px] leading-[18px] text-brand hover:underline"
				onClick={() => setShowInviteModal(true)}
			>
				<FiUsers className="w-4 h-4" />
				Invite a team member to complete this step
			</button>
		</>
	)
}
